module.exports = __webpack_public_path__ + "img/img-finalizado.78be87f7.png";